import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient, { publicApiClient } from '@/core/api/client'

export const miscService = {
	/**
	 * Get countries
	 */
	getCountries(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return publicApiClient.get('/countries', config)
	},

	/**
	 * Get custom CSS
	 */
	getCustomCSS(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return publicApiClient.get('/custom/css', config)
	},

	/**
	 * Get custom settings for the current user, based on the partner
	 */
	getCustomSettings(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return publicApiClient.get('/custom/settings', config)
	},

	/**
	 * Get products
	 */
	getProducts(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/my/products', config)
	},
}

export default miscService
